// src/components/Hero.js
import React from "react";
import Nav from "../general/NavBar.jsx";

const Head = () => {
  function Card({ title, text, color, featured }) {
    // Styles dynamiques de la carte
    const cardStyle = {
      border: `2px solid ${color}`,
      backgroundColor: featured ? "#171717" : "#000000",
    };

    return (
      <li className="formations-card" style={cardStyle}>
        <h2>{title}</h2>
        <p>{text}</p>
      </li>
    );
  }

  return (
    <section className="formation-head" id="formation-hero">
      <Nav />

      <h1>
        NOS <span>FORMATIONS</span>
        <span className="br" /> PROFESSIONNELLES
      </h1>

      <ul>
        {/* 1. MANAGEMENT & LEADERSHIP */}
        {/* <Card
          title="MANAGEMENT & LEADERSHIP"
          text={
            <>
              Développez vos compétences en gestion d’équipe, et stratégie
              d’entreprise.
              <span className="br" />
              Ces programmes vous permettent de renforcer votre capacité à
              diriger et à optimiser les performances.
            </>
          }
          color="var(--fourth-color)"
          featured
        /> */}

        {/* 2. FORMATION AUX MÉTIERS TECHNIQUES (jaune) */}
        {/* <Card
          title="FORMATION AUX MÉTIERS TECHNIQUES"
          text="Nous offrons des formations spécialisées dans différents domaines techniques pour vous permettre de maîtriser les compétences spécifiques et pratiques requises dans votre secteur."
          color="var(--primary-color)"
        /> */}

        {/* 3. FORMATION AUX MÉTIERS TECHNIQUES (bleu) */}
        {/* <Card
          title="FORMATION AUX MÉTIERS TECHNIQUES"
          text={
            <>
              Dans un monde de plus en plus numérique, il est indispensable de
              maîtriser les outils et technologies modernes.
              <span className="br" />
              Nos formations digitales vous aident à rester à jour avec les
              dernières innovations et à booster votre productivité.
            </>
          }
          color="var(--secondary-color)"
          featured
        /> */}

        {/* 4. COMPÉTENCES DIGITALES */}
        <Card
          title="COMPÉTENCES BUREAUTIQUE ET DIGITALE"
          text={
            <>
              Dans un monde de plus en plus numérique, il est indispensable de
              maîtriser les outils et technologies modernes.
              <span className="br" />
              Nos formations digitales vous aident à rester à jour avec les
              dernières innovations et à booster votre productivité.
            </>
          }
          color="var(--secondary-color)"
        />

        {/* 5. FRANÇAIS FLE */}
        <Card
          title="FRANÇAIS FLE"
          text={
            <>
              Apprenez le français pour mieux vous intégrer dans un contexte
              professionnel ou personnel.
              <span className="br" />
              Nos formations sont conçues pour améliorer votre communication et
              vous permettre de saisir toutes les opportunités offertes par un
              environnement francophone.
            </>
          }
          color="var(--third-color)"
          featured
        />

        {/* 6. ANGLAIS PRO – RESTAURATION & L’HÔTELLERIE */}
        <Card
          title="ANGLAIS PRO – RESTAURATION & L’HÔTELLERIE"
          text={
            <>
              Formez-vous à l’anglais spécifique au secteur de la restauration
              et de l’hôtellerie.
              <span className="br" />
              Ces formations vous permettent de mieux répondre aux attentes des
              clients et de renforcer vos compétences techniques indispensables
              dans ce domaine.
            </>
          }
          color="var(--fourth-color)"
        />

        {/* 7. ANGLAIS PROFESSIONNEL */}
        <Card
          title="ANGLAIS PROFESSIONNEL"
          text={
            <>
              Améliorez votre maîtrise de l’anglais dans un contexte
              professionnel.
              <span className="br" />
              Ces programmes vous aident à renforcer vos capacités de
              communication et à développer des stratégies pour mieux interagir
              au sein de votre entreprise.
            </>
          }
          color="var(--primary-color)"
          featured
        />
        <Card
          title="MAITRISER LES BASES DE WORDPRESS"
          text={
            <>
             Vous souhaitez apprendre à installer, configurer et gérer votre propre site internet ? WordPress peut être la solution.
              <span className="br" />
              Maîtriser votre environnement WP de bout-en-bout avec des bases solides à l'aide de cette formation.
            </>
          }
          color="var(--secondary-color)"
        />
        <Card
          title="INTRODUCTION AUX BASES DE WORDPRESS"
          text={
            <>
              Découvrez les fondamentaux de WordPress pour créer, organiser et
              personnaliser votre site web.
              <span className="br" />
              Une formation pratique pour gagner en autonomie et prendre en
              main les outils essentiels.
            </>
          }
          color="var(--secondary-color)"
        />
      </ul>
    </section>
  );
};

export default Head;
